<template>
	<div>
		<div class="box">
			<div class="title">欢迎您注册成为康买用户</div>
			<div class="input">
				<i class="ficon-phone-o iconfont"></i>
				<input type="text" placeholder="请输入手机号" v-model="mobile">
			</div>
			<div class="input F-flex" style="padding-right: 0;">
				<div>
					<i class="ficon-phone-o iconfont"></i>
					<input type="text" placeholder="请输入短信验证码" v-model="code">
				</div>
				<div @click="send" class="yzmbtn text-center" style="color: #fff;">获取验证码</div>
			</div>
			<div class="input">
				<i class="ficon-phone-o iconfont"></i>
				<input type="text" placeholder="请填写诊所名称"  v-model="clinic_name">
			</div>
			<div class="input">
				<i class="ficon-phone-o iconfont"></i>
				<input type="text" placeholder="请填写税号"  v-model="tax_number">
			</div>
			<div class="input">
				<i class="ficon-phone-o iconfont"></i>
				<input type="text" placeholder="请填写邀请码" v-model="invite_code">
			</div>
			<div class="input">
				<i class="ficon-phone-o iconfont"></i>
				<input type="password" placeholder="请输入密码" v-model="password" >
			</div>
			<div class="input">
				<i class="ficon-phone-o iconfont"></i>
				<input type="password" placeholder="请再次输入密码"  v-model="password2">
			</div>
			<div style="padding: 0 10px;">
				<el-checkbox v-model="checked">我同意<span style="color: #0097FE;">《康买用户协议》</span></el-checkbox>
			</div>
			<div class="confirm" @click="confirm">立即注册</div>
		</div>
	</div> 
</template>
<script>
	import {send,register} from '@/api/index.js'
	export default{
		data(){
			return{
				mobile:'',
				code:'',
				code2:'',
				password:'',
				password2:'',
				invite_code:'',//邀请码
				clinic_name:'', //诊所名称
				tax_number:'',   ///税号
				checked:false
			}
		},
		methods:{
			send(){
				send({mobile:this.mobile,event:'register'}).then(res=>{
					if(res.code == 1){
						this.$message({
						  message: res.msg,
						  type: 'success'
						});
						this.code2 = res.data.code
					}else{
						this.$message.error(res.msg);
					}
				});
			},
			confirm(){
				if(!this.checked){
					this.$message.error('请同意相关协议');
					return
				}
				if(this.password2 != this.password){
					this.$message.error('两次输入密码不同');
					return
				}
				let {code,mobile,password,invite_code,clinic_name,tax_number} = this
				register({code,mobile,password,invite_code,clinic_name,tax_number}).then(res => {
					if(res.code == 1){
						this.$message({
						  message: res.msg,
						  type: 'success'
						});
						this.$emit('logType',{
							type:'1'
						})
					}else{
						this.$message.error(res.msg);
					}
				})
			}
		},
		
	}
</script>
<style lang="less" scoped>
	.box{
		width: 511px;
		height: 627px;
		background: #FFFFFF;
		border-radius: 16px;
		margin: 0px auto;
		padding: 40px 50px;
		.title{
			color: #333;
			font-size: 26px;
			margin-bottom: 30px;
		}
		.input{
			height: 42px;
			border-radius: 25px;
			border: 1px solid #D8D8D8;
			padding:  0 30px;
			line-height: 42px;
			font-size: 16px;
			color: #999;
			margin-bottom: 16px;
			input{
				border: none;
			}
			.yzmbtn{
				width: 132px;
				height: 42px;
				background: #0097FE;
				border-radius: 0px 25px 25px 0px;
			}
		}
	}
		
</style>


// WEBPACK FOOTER //
// src/components/register.vue